import React from 'react';
import TextInputField from '../TextInputField/TextInputField';
import { passwordRegisterOptions } from '../patterns';

export default function PasswordField({
  register,
  errors,
  registerOptions = passwordRegisterOptions,
  name = 'password',
  placeholder = 'Password',
  labelText = 'Password',
  labelRightElement = null,
  ...props
}) {
  return <TextInputField
    {...props}
    type="password"
    register={register}
    errors={errors}
    registerOptions={registerOptions}
    name={name}
    placeholder={placeholder}
    labelText={labelText}
    labelRightElement={labelRightElement}
  />;
}
